<template>
  <svg aria-hidden="true" :class="svgClass">
      <use :href="'#icon-'+iconName"/>
  </svg>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props:{
    iconName:{
        type: String,
        default: '',
    },
  },
  setup(props) {
    //获取当前svg目录下的所有svg文件
    const req = require.context('@/assets/svg',false,/\.svg$/);
    //解析
    const requireAll = (requireContext: any) =>{
        return requireContext.keys().map(requireContext);
    }
    const svgClass = computed(() => {
      if (props.iconName) {
        return 'svg-icon ' + props.iconName
      } else {
        return 'svg-icon'
      }
    })
    requireAll(req)
    return {
      svgClass
    }
  },
})
</script>
<style lang="stylus" scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  // fill: currentColor;
  overflow: hidden;
}
</style>
